module.exports = new __parcel__URL__("ring.4766a2b7.png").toString();